module.exports = __webpack_public_path__ + "a481f83a8ddf3ca382811b9fb7d9695f.svg";